<template>
  <div>
    <v-text-field
      v-model="cmpValue"
      :label="label"
      :placeholder="placeholder"
      :rules="rules"
      :maxlength="10"
      class="text-caption"
      dense
      outlined
      dark
      @blur="$emit('blur')"
      @click="$emit('click')"
      @focus="$emit('focus')"
      @keyup="$emit('keyup')"
      @keydown="$emit('keydown')"
      @mousedown="$emit('mousedown')"
      @keypress="keyPress"
      @change="$emit('change', $event, value)"
      v-bind="$attrs"
    ></v-text-field>
  </div>
</template>

<script>
import { dateValidation, formatMaskDate, eventKeyPress } from '@/utils/utils'

export default {
  inheritAttrs: false,

  model: { prop: 'value', event: 'input' },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    maxLength: {
      type: [Number],
      default: 0,
    },
    minLength: {
      type: [Number],
      default: 0,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    inputMask: {
      type: [String],
      default: '##/##/####',
    },
  },
  computed: {
    maxLen() {
      return this.inputMask
        ? Math.max(this.maxLength, this.inputMask.length)
        : 0
    },
    rules() {
      const rules = []

      if (this.minLength > 0) {
        const rule = (value) =>
          (value && value.length >= this.minLength) ||
          `Digite ao menos ${this.minLength} caracteres.`
        rules.push(rule)
      }

      const rule = dateValidation(this.isRequired)
      rules.push(rule)
      return rules
    },

    cmpValue: {
      get: function() {
        return this.humanFormat(this.value)
      },
      set: function(newValue) {
        this.$emit('input', this.machineFormat(newValue))
      },
    },
  },

  methods: {
    humanFormat: function(value) {
      if (value) {
        value = this.formatMask(value, this.inputMask)
      } else {
        value = ''
      }
      return value
    },

    machineFormat(value) {
      return value
    },

    clearInputMask() {
      let val = this.inputMask.replace(/#/g, '0')
      return val.replace(/[^0-9]+/g, '')
    },

    clearValueMask(value) {
      let val = value.replace(' ', '')
      return val.replace(/[^0-9]+/g, '')
    },

    formatMask(value, mask) {
      return formatMaskDate(value, mask)
    },

    keyPress($event) {
      eventKeyPress($event)
    },
  },
}
</script>

<style lang="scss" scoped></style>
